module.exports = __webpack_public_path__ + "img/arrowDown24.d2591c5d.svg";